// AdminMenu.js
// Holding all the buttons for the Admin.

import React from "react";
import styles from "./AdminMenu.module.css";

export const AdminMenu = ({
  activeTab,
  mainMenuStyles,
  handleMainMenuButtonClick,
}) => {
  return (
    <>
      <button
        className={`${mainMenuStyles.tabButton} ${styles.desktopMenu} ${
          activeTab === "admin" ? mainMenuStyles.active : ""
        }`}
        onClick={() => handleMainMenuButtonClick("admin")}
        data-testid="admin-tab-button"
      >
        Admin
      </button>
    </>
  );
};
